import { render, staticRenderFns } from "./clear-chat-bot-popup.vue?vue&type=template&id=788821da&scoped=true&"
import script from "./clear-chat-bot-popup.vue?vue&type=script&lang=js&"
export * from "./clear-chat-bot-popup.vue?vue&type=script&lang=js&"
import style0 from "./clear-chat-bot-popup.vue?vue&type=style&index=0&id=788821da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788821da",
  null
  
)

export default component.exports